import { useEffect } from 'react';

/**
 * Хук с кликом вне компонента
 */
const useOutsideClick = ({ ref, callback }) => {
  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback(e);
    }
  };

  useEffect(() => {
    const rootNode = document.getElementById('root');
    rootNode.addEventListener('click', handleClick, true);
    rootNode.addEventListener('contextmenu', handleClick, true);
    return () => {
      rootNode.removeEventListener('click', handleClick);
      rootNode.removeEventListener('contextmenu', handleClick);
    };
  }, []);
};

export default useOutsideClick;
